import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Customer Car
      {record ? `: ${record.reg_no}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/CustomerCar/Title.js